// extracted by mini-css-extract-plugin
module.exports = {"pagination":"B5uZg","page":"JEslt","active":"sE51c","view-more":"ViVkw"};